import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const panels = [{
  title: 'Got a phone? You’re hired.',
  body: 'Sign up in two minutes. Your first gigs are already waiting in your city.',
  cta: 'Start earning',
  buttonClass: 'bg-accent text-accent-ink'
}, {
  title: 'Need eyes in Lagos by lunch?',
  body: 'First task is on us. After that, you only pay for proof you approve.',
  cta: 'Get an API key',
  buttonClass: 'bg-ink text-canvas'
}];
export function FinalCta() {
  return <section className="mx-auto max-w-6xl px-6 py-28" data-id="element-39" data-mp="1ebxt1nx050wo">
      <div className="grid gap-px overflow-hidden rounded-3xl border border-line bg-line md:grid-cols-2" data-id="element-40" data-mp="1t1wp9l4zy29i">
        {panels.map((panel, i) => <Reveal key={panel.cta} delay={i * 0.06} className="flex flex-col bg-canvas p-8 md:p-12" data-id="element-41" data-mp="1o5y5kaum58ff" data-mpi={i}>
            <h2 className="font-display text-3xl font-semibold tracking-tight" data-id="element-42" data-mp="221jp42i2v00g">{panel.title}</h2>
            <p className="mt-3 text-muted" data-id="element-43" data-mp="1x2goqvd1lhyt">{panel.body}</p>
            <div className="mt-auto pt-10" data-id="element-44" data-mp="n6ntt65fkj0h">
              <a href="#start" className={`group inline-flex items-center gap-2 whitespace-nowrap rounded-full px-6 py-3 font-medium transition-transform duration-150 ease-out active:scale-[0.97] ${panel.buttonClass}`} data-id="element-45" data-mp="n7ywf2n53kq0">
                {panel.cta}
                <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-46" data-mp="120ilizdgfrog" />
              </a>
            </div>
          </Reveal>)}
      </div>
    </section>;
}